export const moduleName = 'table'

export const actionTypes = {}

export const getterTypes = {
  GETTER_CHECKED_ROWS: 'GETTER_CHECKED_ROWS'
}

export const mutationTypes = {
  MUTATION_SET_CHECKED_ROW: 'MUTATION_SET_CHECKED_ROW',
  MUTATION_SET_CHECKED_ROWS: 'MUTATION_SET_CHECKED_ROWS',
  MUTATION_UNSET_CHECKED_ROWS: 'MUTATION_UNSET_CHECKED_ROWS'
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    tables: {}
  }),

  actions: {},

  mutations: {
    [mutationTypes.MUTATION_UNSET_CHECKED_ROWS] (state, tableName) {
      state.tables = {
        ...state.tables,
        [tableName]: []
      }
    },
    [mutationTypes.MUTATION_SET_CHECKED_ROW] (state, [tableName, row]) {
      if (Object.keys(state.tables).includes(tableName)) {
        const targetIndex = state.tables[tableName].indexOf(row)
        if (targetIndex >= 0) {
          state.tables[tableName].splice(targetIndex, 1)
        } else {
          state.tables[tableName].push(row)
        }
      } else {
        state.tables[tableName] = [row]
      }

      state.tables = {
        ...state.tables
      }
    },
    [mutationTypes.MUTATION_SET_CHECKED_ROWS] (state, [tableName, rows]) {
      if (Object.keys(state.tables).includes(tableName)) {
        if (state.tables[tableName].length > 0 && state.tables[tableName].every(row => rows.includes(row))) {
          state.tables[tableName] = []
        } else {
          state.tables[tableName] = [...rows]
        }
      }

      state.tables = {
        ...state.tables
      }
    }
  },

  getters: {
    [getterTypes.GETTER_CHECKED_ROWS]: (state) => state.tables
  }
}
